import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { useState } from "react";
import { ANNOUNCEMENT, Announcement, markAnnouncementSeen, shouldShowAnnouncement } from "../utils/announcement";

// Shown once per browser on the tool page; the content lives in utils/announcement.ts.
// A web address written into an announcement paragraph becomes a link (shown without the scheme), so a
// pointer such as the previous-release instance is clickable without a second button.
const URL_IN_TEXT = /(https?:\/\/[^\s,;)]+)/g;
export const linkify = (text: string) =>
    text.split(URL_IN_TEXT).map((part, i) =>
        URL_IN_TEXT.test(part) ? (
            <a key={i} href={part} target="_blank" rel="noopener noreferrer">
                {part.replace(/^https?:\/\//, "")}
            </a>
        ) : (
            part
        ),
    );

export const AnnouncementDialog = ({ announcement = ANNOUNCEMENT }: { announcement?: Announcement | null }) => {
    const [open, setOpen] = useState(() => shouldShowAnnouncement(announcement));
    if (!announcement || !open) {
        return null;
    }
    const close = () => {
        markAnnouncementSeen(announcement);
        setOpen(false);
    };
    return (
        <Dialog open={open} onClose={close} maxWidth="sm" fullWidth aria-labelledby="announcement-title">
            <DialogTitle id="announcement-title">{announcement.title}</DialogTitle>
            <DialogContent>
                {announcement.paragraphs.map((text) => (
                    <Typography key={text} paragraph>
                        {linkify(text)}
                    </Typography>
                ))}
            </DialogContent>
            <DialogActions>
                <Button href={announcement.linkUrl} target="_blank" rel="noopener noreferrer" onClick={close}>
                    {announcement.linkLabel}
                </Button>
                <Button variant="contained" onClick={close}>
                    Got it
                </Button>
            </DialogActions>
        </Dialog>
    );
};
